/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/plugin.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const PluginRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const lookups: any = {
        Plugin: (plugin: any, recordData: any) => (recordData?.Plugin ? 'Yes' : 'No'),
    };

    const items = getFieldChangeItems(oldRecord, newRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field, lookups }),
    );

    return <FieldChangeGrid items={items} />;
};

export { PluginRecordChangeGrid };
